<section class="@container h-full">
  <div class="flex h-full flex-col gap-4 @xl:flex-row">
    <div class="flex shrink-0 flex-col gap-4 rounded-lg border border-gray-200 bg-gray-50 py-4 pr-6 pl-2 @xl:w-48">
      <mat-radio-group
        [(ngModel)]="gridType"
        (change)="onGridTypeChange($event.value)"
        class="flex flex-col items-start gap-1.5 [&_.mdc-radio]:scale-75"
        aria-label="Select a grid type"
      >
        @for (type of GRID_TYPES; track type) {
          <mat-radio-button [value]="type">
            <span class="text-xs font-semibold text-gray-600">{{ gridTypeLabels[type] | translate }}</span>
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>

    <div class="flex flex-1 flex-col gap-2.5 rounded-lg border border-gray-200 bg-gray-50 py-4 pr-4 pl-6">
      <ng-template #gridOptionTpl let-item="item">
        <span>{{ item.name }}</span>
        <span class="select-grid-is-default">{{ item.isDefault ? ('GRID_ENGINE.GRID_MANAGER_POPUP.DEFAULT_GRID' | translate) : '' }}</span>
      </ng-template>
      <iot-platform-ui-form-group [fields]="fields()" [group]="form" />
    </div>
  </div>
</section>
